//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import NoData from '@/components/NoData/NoData';
import { valsubstr32addbr } from '@/utils/index';
export default {
  components: {
    NoData: NoData
  },
  data: function data() {
    return {
      currentPage: 1,
      loading: false,
      tableheight: 512,
      group: {
        userGroupName: null,
        groupDescribe: null,
        userIds: null,
        id: null
      },
      userList: [],
      id: null
    };
  },
  created: function created() {
    // 获取路由里面的type参数
    this.id = this.$route.query.id;
    this.getData();
    this.getUsers();
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.tableheight = window.innerHeight - 332;
      // 监听窗口大小变化
      var self = this;
      window.onresize = function () {
        self.tableheight = window.innerHeight - 332;
      };
    });
  },
  methods: {
    getData: function getData() {
      var _this = this;
      this.loading = true;
      this.$API.getRequest({
        url: '/platform/userGroup/searchUserGroupDetail',
        data: {
          userGroupId: this.id
        }
      }).then(function (res) {
        _this.loading = false;
        if (res.code === '0000000000') {
          _this.group = res.result;
          _this.group.id = _this.id;
        }
      });
    },
    getUsers: function getUsers() {
      var _this2 = this;
      this.loading = true;
      this.$API.postRequest({
        url: '/platform/userGroup/searchUserGroupRefPage',
        data: {
          pageNum: 1,
          pageSize: -1,
          userGroupIds: [this.id]
        }
      }).then(function (res) {
        _this2.loading = false;
        if (res.code === '0000000000') {
          _this2.userList = res.result.records;
        }
      });
    },
    delUserGroup: function delUserGroup() {
      var _this3 = this;
      this.$API.getRequest({
        url: '/platform/userGroup/deleteUserGroupById',
        data: {
          userGroupId: this.id
        }
      }).then(function (res) {
        if (res.code === '0000000000') {
          _this3.$message({
            message: '删除成功',
            type: 'success'
          });
          _this3.back();
        }
      });
    },
    goToEdit: function goToEdit() {
      this.$router.push({
        path: '/system/addusergroup',
        query: {
          id: this.group.id
        }
      });
    },
    ToBreak: function ToBreak(val) {
      if (val) {
        return valsubstr32addbr(val);
      }
    },
    headerdragend: function headerdragend(newWidth, oldWidth, column) {
      if (newWidth < column.minWidth) {
        column.width = column.minWidth;
      }
    },
    back: function back() {
      this.$router.push('/system/usergroup');
    }
  }
};